import Cookies from "../cookies";
import * as errors from "../errors/errors";

const AUTH_ERROR_KEY = "authError";

export default function checkAuthError(): boolean {
    const authErrorCookie = Cookies.get(AUTH_ERROR_KEY);
    if (authErrorCookie) {
        const authError = JSON.parse(authErrorCookie);
        errors.handleError(errors.createError(authError.status, authError.response));
        Cookies.remove(AUTH_ERROR_KEY);

        return true;
    }

    return false;
}
